import { COMPONENT_TYPE } from '../pricing-constants';

const AddPricingWrapper = ({ componentType, children }) => {
    return componentType === COMPONENT_TYPE.ADD ? children : null;
};
export default AddPricingWrapper;
